import { SchemaTypeIds } from "@contentchef/contentchef-types";
import { Input, Select } from "antd";
import React from "react";
import { DynamicFieldTypes, FieldText } from "../FormFields";
import { defaultFieldWrapper } from "./DefaultFieldWrapper";
import { ConstraintsToMatch, fieldMatchersUtils } from "./FieldMatchersUtils";
import { FieldMatcher } from "./FormFieldMatchersFactory";

const Option = Select.Option;

export class TextTypeMatcher implements FieldMatcher {
  maybeCreateComponent(
    id: string,
    userLocale: string,
    onChange: (e: any) => void,
    field: DynamicFieldTypes,
  ): JSX.Element | null {
    if (!fieldMatchersUtils.typeMatcher(field, SchemaTypeIds.TEXT)) {
      return null;
    }
    const fieldText = field as FieldText;
    const placeholder = fieldMatchersUtils.generateFieldPlaceholder(field, userLocale);

    function elementToRender(disabled: boolean) {
      return (
        <Input
          id={id}
          disabled={disabled || fieldText.disabled}
          placeholder={placeholder}
          value={fieldText.value}
          onChange={onChange}
        />
      );
    }

    return defaultFieldWrapper(elementToRender);
  }
}

export class TextWithListOfValuesMatcher implements FieldMatcher {
  maybeCreateComponent(
    id: string,
    userLocale: string,
    onChange: (e: any) => void,
    field: DynamicFieldTypes,
  ): JSX.Element | null {
    if (!fieldMatchersUtils.typeAndConstraintMatcher(field, SchemaTypeIds.TEXT, ConstraintsToMatch.listOfValues)) {
      return null;
    }
    const placeholder = fieldMatchersUtils.generateFieldPlaceholder(field, userLocale);
    const fieldText = field as FieldText;

    function customOnChange(value: string | undefined) {
      onChange(value === undefined ? "" : value);
    }

    function elementToRender(disabled: boolean) {
      return (
        <Select
          id={id}
          disabled={disabled || field.disabled}
          placeholder={placeholder}
          value={fieldText.value}
          onChange={customOnChange}
          allowClear={true}
          style={{ width: "100%" }}
        >
          {fieldText.constraints.listOfValues!.map((value) => {
            return (
              <Option key={value.code} value={value.code}>
                {value.labels[userLocale] || value.labels[field.locale]}
              </Option>
            );
          })}
        </Select>
      );
    }

    return defaultFieldWrapper(elementToRender);
  }
}
